import { useCallback, useMemo, useState } from 'react';
import { diffRules, isEmptyPatch, setLeaf, toDraft, validateRules } from './rulesForm';

/** Draft state for one GoalRush rules form, saved as a whole with one button. */
const useRulesForm = (rules) => {
  const [initial, setInitial] = useState(() => toDraft(rules));
  const [draft, setDraft] = useState(() => toDraft(rules));

  const onChange = useCallback((path, value) => setDraft((prev) => setLeaf(prev, path, value)), []);

  const errors = useMemo(() => validateRules(draft), [draft]);
  const patch = useMemo(() => diffRules(initial, draft), [initial, draft]);

  /** After a save: the server's values become both the baseline and the draft. */
  const markSaved = useCallback((savedRules) => {
    const saved = toDraft(savedRules);
    setInitial(saved);
    setDraft(saved);
  }, []);

  return {
    draft,
    errors,
    patch,
    dirty: !isEmptyPatch(patch),
    valid: Object.keys(errors).length === 0,
    onChange,
    markSaved
  };
};

export default useRulesForm;
